import React, { FC } from 'react'

function getPadding(option: any){
	if(option.indexOf(`%`) > -1){
		return option
	}
	if(option === `widescreen`){
		return `56.25%`
	}
	if(option === `standard`){
		return `75%`
	}
	if(option.indexOf(`:`) > -1){
		option = option.split(`:`)
		option = option[1] / option[0]
		option = option * 100
		return `${option}%`
	}
	return option
}

function getId(str: string): string {
  const parts = str.split(`/`)
  if(parts.length <= 0) return ''
  let part = parts.pop()
  if(!part) return ''
	if (part.indexOf(`?v=`) > -1){
		part = str.split(`?v=`)[1]
	}
	part = part.split(`?`)[0]
	part = part.split(`&`)[0]
	return part
}

interface YouTubeEmbedProps {
  id: string,
  className?: string,
  aspectRatio?: string,
  prependSrc?: string,
  appendSrc?: string,
}

const YouTubeEmbed: FC<React.PropsWithChildren<YouTubeEmbedProps>> = ({
  id,
  className,
  aspectRatio = `56.25%`,
  prependSrc = 'https://www.youtube.com/embed/',
  appendSrc = '',
}) => {
  const embedLink = prependSrc + getId(id) + appendSrc
  return (
    <div 
      style={{
        position: `relative`,
        paddingBottom: getPadding(aspectRatio),
        width: `100%`,
        height: 0,
      }}
      className={ className }
    >
      <iframe
        width="100%"
        height="100%"
        src={embedLink}
        frameBorder='0'
        allow='autoplay; encrypted-media'
        allowFullScreen
        style={{
          position: `absolute`,
          top: 0,
          left: 0,
          width: `100%`,
          height: `100%`,
        }}
        />
    </div>
  )
}

export default YouTubeEmbed